require('./angular-cookies');
module.exports = 'ngCookies';


/*** EXPORTS FROM exports-loader ***/
module.exports = "ngCookies";


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-cookies/index.js
 ** module id = 3073
 ** module chunks = 2
 **/